import React, { useContext, useEffect, useState } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";

import { getBasketData, refetchBasketData } from "../queries/global";

import {
  NotificationContext,
  handleError,
} from "../context/NotificationContext";

import config from "../config/config";
import * as QUERIES from "../queries/query-functions";
import PromoCodeInput from "../components/promo-code-input";


const guest_user_upsell_with_discount =
  config.OPTION_FIELDS.guest_user_upsell?.with_discount;

const guest_user_upsell_no_discount =
  config.OPTION_FIELDS.guest_user_upsell?.no_discount;

const member_message_with_discount =
  config.OPTION_FIELDS.member_message?.with_discount;

const member_message_no_discount =
  config.OPTION_FIELDS.member_message?.no_discount;

const membershipId = config.OPTION_FIELDS.guest_user_upsell?.spektrix_membership?.innerHTML ?? null;

export default function MembershipPrompt({isSummary = false, hasSubscriptions = false}) {
  const { notification, setNotification } = useContext(NotificationContext);
  const { data: basketData } = getBasketData();

  const {
    isFetching: isPotentialDiscountDataFetching,
    data: potentialDiscountData,
  } = useQuery({
    queryKey: ["potentialDiscountData", membershipId],
    queryFn: () => QUERIES.getPotentialDiscount(membershipId),
    refetchOnWindowFocus: false,
    retry: false,
  });

  const addMembership = useMutation({
    mutationFn: () =>
      QUERIES.addMembership([{ membership: membershipId, autoRenew: true }]),
    onError: (error) => {
      handleError(error.message, setNotification);
    },
    onSuccess: (data) => {
      refetchBasketData();
    },
  });
// console.log("potentialDiscountData", potentialDiscountData)



  if (!basketData || isPotentialDiscountDataFetching) return;


  return (
    <section className="membership-prompt">
        {isSummary ? (
          <>
            <h2 className="membership-prompt__title">Savings</h2>
            <PromoCodeInput />

            {basketData.totalDiscount ?
                <div className='membership-prompt__discount'>
                    <span className="membership-prompt__discount-title">You’re saving with these offers</span>
                    { basketData?.offers.map(offer => 
                      <div className="membership-prompt__discount-row">
                        <span>{offer.name}</span>
                        {offer.htmlDescription ?
                            <p dangerouslySetInnerHTML={{__html: offer.htmlDescription}}></p>
                        :null}
                      </div>
                    )}
                    <div className="membership-prompt__discount-footer">
                      <span>Total savings</span>
                      <span>-£{basketData.totalDiscount.toFixed(2)}</span>
                    </div>
                </div>
                : null
            }
            { // If membership is in basket say thank you
              hasSubscriptions ? 
                potentialDiscountData?.totalDiscount ?
                  <div class="booking-pathway__thanks-message">
                        <h5 className='booking-pathway__thanks-message__title type-h5'>
                          { member_message_with_discount.title ?
                              member_message_with_discount.title.innerHTML : 'Thank you for joining us'}
                        </h5>
                        {
                          guest_user_upsell_with_discount.message &&
                            <div class='booking-pathway__thanks-message__content' dangerouslySetInnerHTML={{__html: guest_user_upsell_with_discount.message.innerHTML}}></div>
                        }
                  </div>
                  : <div class="booking-pathway__thanks-message">
                        <h5 className='booking-pathway__thanks-message__title type-h5'>
                          { member_message_no_discount.title ?
                              member_message_no_discount.title.innerHTML : 'Thank you for joining us'}
                        </h5>
                        {
                          guest_user_upsell_no_discount.message &&
                            <div class='booking-pathway__thanks-message__content' dangerouslySetInnerHTML={{__html: guest_user_upsell_no_discount.message.innerHTML}}></div>
                        }
                  </div>
                : null
              }
          </>
        ) : (!hasSubscriptions && membershipId) ? 
            ( potentialDiscountData?.totalDiscount ? (
              // If there is potential for a discount show potential discount amount and add memebrship button
              <div class="prompt prompt--membership">
                  <header className='prompt__header'>                
                    {guest_user_upsell_with_discount.title ? 
                      <>
                        <h2 className='prompt__title'>{guest_user_upsell_with_discount.title.innerHTML.replace('{{discountamount}}', '£' + (potentialDiscountData.totalDiscount - basketData.totalDiscount).toFixed(2))}</h2>
                        {guest_user_upsell_with_discount.price && <p className='prompt__price'>{guest_user_upsell_with_discount.price.innerHTML} for 12 months</p>}
                      </>
                      : <h2>Become a Playhouse Pass member to save now</h2>
                    }
                  </header>
                {
                  guest_user_upsell_with_discount.message &&
                    <div class='prompt__content' dangerouslySetInnerHTML={{__html: guest_user_upsell_with_discount.message.innerHTML}}></div>
                }
                <div className='prompt__button'>
                  <button className='btn btn--yellow-white' 
                      type="button" 
                      onClick={() => { 
                        addMembership.mutate();
                      }}>
                        Add to basket
                  </button>
                  {
                    guest_user_upsell_with_discount.prise && <p className='prompt__button-text'>£{guest_user_upsell_with_discount.prise.innerHTML} discount will automatically apply to your basket.</p>
                  }
                </div>
              </div>
              ) : guest_user_upsell_no_discount ? (
                // Else show message specified by client
                <div class="prompt prompt--membership">
                    <header className='prompt__header'>         
                        {guest_user_upsell_no_discount.title ?         
                          <>
                            <h2 className='prompt__title'>{guest_user_upsell_no_discount.title.innerHTML.replace('{{discountamount}}', '')}</h2>
                            {guest_user_upsell_no_discount.price && <p className='prompt__price'>{guest_user_upsell_no_discount.price.innerHTML} for 12 months</p>}
                          </>
                          : <h2 className='prompt__title'>You could save on selected shows with a Playhouse Pass</h2>
                        }
                    </header>
                  
                  {
                    guest_user_upsell_no_discount.message &&
                      <div class='prompt__content' dangerouslySetInnerHTML={{__html: guest_user_upsell_no_discount.message.innerHTML}}></div>
                  }
                  <div className='prompt__button'>
                    <button className='btn btn--yellow-white' 
                        type="button" 
                        onClick={() => { 
                          addMembership.mutate();
                        }}>
                          Add to basket
                    </button>
                  </div>
                </div>
          ) : null) 
        : null
      }

    </section>
  );
}
